// don't start until page is interactive
document.addEventListener('DOMContentLoaded', function () {
  // Init variables
  let lastScrollPos = 0;
  let isTicking = false;

  // Element Selectors
  const stickyContainer = document.getElementById('product-sticky-container');
  const stickyMain = document.getElementById('product-sticky-main');
  const stickyInner = document.getElementById('product-sticky-inner');
  if (!stickyContainer || !stickyMain || !stickyInner) return;

  const buttonsContainer = stickyContainer.querySelector('.js-buy-buttons');
  if (!buttonsContainer) return;
  const stickyMenuTarget = stickyInner.querySelector('.js-sticky-content-menu');
  const stickyHeader = document.querySelector('sticky-header');

  // The scroll listener needed for scroll-direction logic
  window.addEventListener('scroll', () => {
    if (!isTicking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        isTicking = false;
      });
      isTicking = true;
    }
  }, { passive: true });

  function handleScroll() {
    // 1. READ phase
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight - 1 : 0;
    const scrollPos = window.scrollY;
    const innerWidth = window.innerWidth;

    // 2. WRITE phase
    if (innerWidth >= 990) {
      stickyMain.classList.remove('hidden-at-page-bottom');
      stickyMain.style.top = scrollPos < lastScrollPos ? `${stickyHeaderHeight}px` : '0';
    } else {
      stickyMain.style.top = ''; // Reset desktop view value
    }
    
    lastScrollPos = scrollPos;
  }

  // Hide the sticky buy bar when reaching the footer to allow access
  const footerElement = document.querySelector('footer');
  if (footerElement) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyMain.classList.toggle('hidden-at-page-bottom', entry.isIntersecting);
      });
    });
    footerObserver.observe(footerElement);
  }

  /**
   * When user is at the top of the page and btn not visible in viewport yet,
   * this script enables the floating add-to-cart mode.
   * Mobile only.
   */
  const floatingQuery = window.matchMedia('(max-width: 749px)');
  let isButtonInViewport = true;

  const refreshFloating = () => {
    const shouldBeFloating =
      floatingQuery.matches && !stickyMain.classList.contains('appears-sticky') && !isButtonInViewport;
    stickyMain.classList.toggle('floating-add-to-cart', shouldBeFloating);
    document.body.classList.toggle('has-floating-add-to-cart', shouldBeFloating);
  };

  const handleButtonIntersection = (entries) => {
    entries.forEach((entry) => {
      isButtonInViewport = entry.isIntersecting;
    });
    refreshFloating();
  };

  // The observer only fires when the button's visibility changes, so crossing
  // the breakpoint mid-scroll needs its own re-evaluation.
  floatingQuery.addEventListener('change', refreshFloating);

  /**
   * Manages the main sticky bar state.
   *
   * The observed container ends at the add-to-cart button, so "container fully
   * above the viewport" means "the CTA has scrolled off the top".
   */
  const handleStickyIntersection = (entries) => {
    entries.forEach((entry) => {
      const isContainerAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;

      if (isContainerAboveViewport) {
        // enter sticky mode
        if (!stickyMain.classList.contains('appears-sticky')) {
          ensureStickyContentMenu(stickyMenuTarget);
          // Reserve the space the bar is about to vacate
          stickyContainer.style.height = `${stickyMain.getBoundingClientRect().height}px`;
          const variantPickers = stickyContainer.querySelectorAll('.js-variant-option-picker');
          variantPickers.forEach((variantPicker) => updateVariantSelector(variantPicker));
          document.body.classList.add('has-sticky-buy-bar');
          stickyMain.classList.add('appears-sticky');
          stickyMenuTarget?.removeAttribute('hidden');
        }
      } else {
        // exit sticky mode
        if (stickyMain.classList.contains('appears-sticky')) {
          stickyContainer.removeAttribute('style');
          document.body.classList.remove('has-sticky-buy-bar');
          stickyMain.classList.remove('appears-sticky');
          stickyMenuTarget?.setAttribute('hidden', '');

          // clear event handled inside sticky view
          const productForm = stickyContainer.querySelector('product-form');
          const variantRadios = stickyContainer.querySelector('variant-radios');
          if (productForm?.onVariantChanged && variantRadios) {
            variantRadios.removeEventListener('variant:changed', productForm.onVariantChanged);
          }
        }
      }
    });
  };

  // Create and start the observers
  const stickyObserver = new IntersectionObserver(handleStickyIntersection, { threshold: 0 });
  const btnObserver = new IntersectionObserver(handleButtonIntersection, { threshold: 0 });
  stickyObserver.observe(stickyContainer);
  btnObserver.observe(buttonsContainer);

  function ensureStickyContentMenu(target, force = false) {
    if (!target) return;
    if (!force && target.hasChildNodes()) return;

    const source = document.querySelector('.product-content-menu-section:not([data-sticky-menu-clone]):not(.product-content-menu-section--empty)');
    if (!source) return;

    target.replaceChildren();
    const clone = source.cloneNode(true);
    clone.setAttribute('data-sticky-menu-clone', '');
    clone.classList.remove('product-content-menu-section--empty');
    clone.classList.add('product-content-menu--sticky');
    target.appendChild(clone);
  }

  document.addEventListener('product-content-menu:ready', () => {
    const target = stickyInner?.querySelector('.js-sticky-content-menu');
    if (!target) return;
    ensureStickyContentMenu(target, true);
  });

  // Syncs dropdowns with pill-style variant selectors
  function updateVariantSelector(variantPicker) {
    // Find the currently selected variant from the pill-style radio inputs
    const activeVariant = variantPicker.querySelector('input[type=radio]:checked');
    const activeVariantValue = activeVariant?.value;
    if (activeVariantValue) {
      // Find the currently selected option in the dropdown
      const dropdownSelectedOption = variantPicker.querySelector('.js-option.selected');
      // If the dropdown is out of sync, update its display and selected state
      if (!dropdownSelectedOption || dropdownSelectedOption.dataset.optionValue != activeVariantValue) {
        variantPicker.querySelector('.js-dropdown-selected .js-text').textContent = activeVariantValue;
        dropdownSelectedOption?.classList.remove('selected');
        const matchingOption = Array.from(variantPicker.querySelectorAll('.js-option')).find(
          (option) => option.dataset.optionValue === activeVariantValue,
        );
        matchingOption?.classList.add('selected');
      }
    }
  }
});
